import {Injectable, signal, WritableSignal} from '@angular/core';
import {SpinnerPort} from '@shared/application/ports/spinner/spinner.port';

@Injectable({providedIn: 'root'})
export class SpinnerAdapter implements SpinnerPort {

  public visible: WritableSignal<boolean> = signal(false);

  public setVisible() {
    this.visible.set(true);
  }

  public setHidden() {
    this.visible.set(false);
  }

}
